import { useMemo } from 'react'

import { useGetEventTypesCollectionQuery } from 'common'

const filterEligibleEventTypes = (eventTypesData) => {
  const eventTypes = (eventTypesData?.results ?? []).flatMap((block) => block.event_types ?? [])
  return eventTypes.filter((et) => (
    et.active
        && et?.type === 'StandardEventType'
        && et?.kind_name === 'one_on_one'
        && et?.payment === null
        && et?.parent_id === null // exclude admin-managed event types
  ))
}

export const useGetAssistantEligibleEventTypes = ({ skip = false } = {}) => {
  const {
    data: eventTypesData,
    isLoading: areEventTypesLoading,
    isFetching: areEventTypesFetching,
    isError: isEventTypesError,
  } = useGetEventTypesCollectionQuery({
    scope: 'personal',
    skipPagination: true,
  }, { skip })

  const isEventTypesPending = !skip
    && (areEventTypesLoading || (areEventTypesFetching && !eventTypesData))

  const eligibleEventTypes = useMemo(
    () => filterEligibleEventTypes(eventTypesData),
    [eventTypesData]
  )

  return {
    eligibleEventTypes,
    isLoading: areEventTypesLoading,
    isFetching: areEventTypesFetching,
    isError: isEventTypesError,
    isEventTypesPending,
  }
}
